import React from "react";

import { CallCountWithIconContainerStyled } from "./call-count-with-icon.styles";

import {
  IncomingCallIcon,
  IncomingMissbellIcon,
  OutgoingCallIcon,
  ReturnedCallIcon,
} from "../../../../assets/svgComponents";

const typeToImageMap: Record<string, React.ReactElement> = {
  outgoing: <OutgoingCallIcon />,
  incoming: <IncomingCallIcon />,
  returned: <ReturnedCallIcon />,
  missed: <IncomingMissbellIcon />,
};

interface CallCountWithIconProps {
  type: string;
  count: number;
}

const CallCountWithIcon: React.FC<CallCountWithIconProps> = ({
  type,
  count,
}) => {
  const image = typeToImageMap[type];
  return (
    <CallCountWithIconContainerStyled>
      {image}
      <span>{count}</span>
    </CallCountWithIconContainerStyled>
  );
};

export default CallCountWithIcon;
